import React from "react";
import HomeUI from "./HomeUI";
import useFetch from "../../hooks/useFetch";

export const Home = () => {
  let {
    data: articles,
    loading,
    error,
  } = useFetch(`${process.env.REACT_APP_API_URL}/news`);

  articles = articles.results;

  return <HomeUI error={error} loading={loading} articles={articles} />;
};
